import React, { useState } from "react"
import Slider from "react-slick"
import Loader from "react-loader-spinner"
import "./capacidades-modal-info.scss"

const ModalCapacidadesInfo = props => {
  const { logo, infoModal, isMobile } = props

  const [activeStep, setActiveStep] = useState(0)
  const [indicatorPositionY, setIndocatorPositionY] = useState(0)
  const [isAnimate, setIsAnimate] = useState(true)
  const [isModal, setIsModal] = useState(false)
  const [isLoadVideo, setIsLoadVideo] = useState(false)
  const refList = React.useRef(null)
  const slider = React.useRef(null)

  const handleAnimate = () => {
    setIsAnimate(false)
    setTimeout(() => {
      setIsAnimate(true)
    }, 100)
  }

  const setIndicatorPosition = index => {
    let calcPositionY = refList.current.childNodes[index].offsetTop
    setIndocatorPositionY(calcPositionY)
    handleAnimate()
  }

  const handleNext = () => {
    if (activeStep >= 0 && activeStep < infoModal.length - 1) {
      setIndicatorPosition(activeStep + 1)
      setActiveStep(value => value + 1)
      slider.current.slickNext()
    }
  }

  const handleBack = () => {
    if (activeStep > 0 && activeStep <= infoModal.length - 1) {
      setIndicatorPosition(activeStep - 1)
      setActiveStep(value => value - 1)
      slider.current.slickPrev()
    }
  }

  const settings = {
    dots: false,
    fade: true,
    infinite: false,
    arrows: false,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    accessibility: false,
    draggable: false,
    swipe: false,
  }

  React.useEffect(() => {
    document.body.style.overflow = isModal ? "hidden" : "initial"
    let res = document.getElementsByTagName("iframe")[0]
    res &&
      (res.onload = function () {
        setIsLoadVideo(true)
      })

    //Scroll to logo
    let logoSelector = document.getElementById("logo")
    logoSelector && logoSelector.scrollIntoView({ behavior: "smooth" })
  }, [isModal])

  return (
    <div
      className={
        "f-modalCapacidadesInfo" +
        (props.isLogros ? " f-modalCapacidadesInfo--logros" : "")
      }
    >
      <figure className="f-modalCapacidadesInfo__logo" id="logo">
        <img src={logo} alt="logo modal" />
      </figure>

      <div className="f-modalCapacidadesInfo__content">
        <div className="f-modalCapacidadesInfo__content__list">
          <i
            className="far fa-chevron-right f-modalCapacidadesInfo__content__list__indicator"
            style={{
              top: indicatorPositionY,
            }}
          ></i>

          <ul
            className="f-modalCapacidadesInfo__content__list__container"
            ref={refList}
          >
            {infoModal.map((element, index) => {
              return (
                <li
                  key={index}
                  className={
                    "f-modalCapacidadesInfo__content__list__item" +
                    (index === activeStep
                      ? " f-modalCapacidadesInfo__content__list__item--active"
                      : "")
                  }
                  onClick={() => {
                    setActiveStep(index)
                    setIndicatorPosition(index)
                    slider.current.slickGoTo(index)
                  }}
                >
                  {element.titulo}
                </li>
              )
            })}
          </ul>
        </div>

        <div className="f-modalCapacidadesInfo__content__img">
          <div className="f-modalCapacidadesInfo__content__img__circle"></div>
          <div className="f-modalCapacidadesInfo__content__img__circle"></div>
          {infoModal[activeStep]?.img && (
            <img
              src={infoModal[activeStep].img}
              alt="img mundo"
              className={
                "" +
                (isAnimate ? " animate" : "") +
                (infoModal[activeStep]?.video ? " video" : "")
              }
              onClick={() => {
                if (infoModal[activeStep]?.video) {
                  setIsModal(true)
                }
              }}
            />
          )}
        </div>

        <Slider
          {...settings}
          ref={slider}
          className="f-modalCapacidadesInfo__content__info"
        >
          {infoModal.map((element, index) => {
            return (
              <div
                className="f-modalCapacidadesInfo__content__info"
                key={index}
              >
                {element.subtitulo && (
                  <h2 className="f-modalCapacidadesInfo__content__info__subtitle">
                    {element.subtitulo}
                  </h2>
                )}
                {element.descripcion && (
                  <div className="f-modalCapacidadesInfo__content__info__description">
                    {element.descripcion}
                  </div>
                )}

                {element.subtitulo || element.descripcion || isMobile ? (
                  <div className="f-modalCapacidadesInfo__content__info__buttons">
                    <i
                      className={
                        "far fa-chevron-left" +
                        (activeStep === 0 ? " disabled" : "")
                      }
                      onClick={handleBack}
                    ></i>
                    <i
                      className={
                        "far fa-chevron-right" +
                        (activeStep === infoModal.length - 1 ? " disabled" : "")
                      }
                      onClick={handleNext}
                    ></i>
                  </div>
                ) : (
                  <div></div>
                )}
              </div>
            )
          })}
        </Slider>
      </div>

      {isModal && (
        <div className="f-modalCapacidadesInfo__video">
          <button
            className="f-modalCapacidades-content__close f-modalCapacidadesInfo__video__close-button"
            onClick={() => setIsModal(false)}
          >
            <i className="f-modalCapacidades-content__close-icon" />
          </button>

          <div
            className="f-container-video"
            content={infoModal[activeStep].video}
          >
            <iframe
              width="100%"
              height="100%"
              frameBorder="0"
              sandbox="allow-popups allow-same-origin allow-scripts"
              scrolling="no"
              src={
                infoModal[activeStep].video?.includes("youtube")
                  ? infoModal[activeStep].video?.replace("watch?v=", "embed/")
                  : infoModal[activeStep].video
              }
              allowFullScreen={true} webkitallowfullscreen="true" mozallowfullscreen="true"
              sandbox="allow-forms allow-scripts allow-same-origin" 
              allow="microphone; camera; fullscreen"
              className="f-container-video-iframe"
            />

            {!isLoadVideo && (
              <div className="f-load-container">
                <Loader
                  type="Oval"
                  color="#006fce"
                  height={100}
                  width={100}
                  className="f-comment-loader"
                />
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  )
}

export default ModalCapacidadesInfo
